import i18n from "i18next";
import { initReactI18next } from 'react-i18next';

import en from './translations/en.json';
import ja from './translations/ja.json';

const language = localStorage.getItem('selectedLanguage') || 'ja'

const resources = {
    en : { translation : en},
    ja : { translation : ja}
};

// replace this by json files

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: language,
        fallbackLng: "ja",
        interpolation: {
            escapeValue: false
        },
    })

export default i18n;



